import './util/polyfills';

import * as Bugsnag from 'bugsnag-js';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import Root from './components/Root';
import { defineExternalApi, defineLegacyApi, validateStartConfig } from './defineExternalApi';
import configureStore from './store';
import { InlineConfig } from './typedefs/external';
import { DICWindow } from './typedefs/window';

let store: any;
const rootDivId = 'di-conversations-embed-root';

declare var window: DICWindow;
window.DIConv = window.DIConv || {};

// this is the function that the loader will call automatically to run the app
window.DIConv.start = (config: InlineConfig) => {
    configureBugsnag(config.guid);
    validateStartConfig(config);
    renderApp(config);
    defineExternalApi(store);
    defineLegacyApi(store);

    // handle legacy DICKit usage - copy all properties and methods to DICKit and warn
    if (window.DICKit) {
        console.warn(`DICKit is deprecated and will be removed. Please use DIConv instead.`);
        if (window.Bugsnag) {
            window.Bugsnag.notify(`Legacy DICKit Usage`, `Legacy DICKit Usage`, null, 'info');
        }
    }
    window.DICKit = { ...window.DIConv };
};

function configureBugsnag(guid: string) {
    if (window.Bugsnag) {
        window.DIConv.Bugsnag = Bugsnag.noConflict();
        window.DIConv.Bugsnag.apiKey = '36923ffd0fb1f32c36045e708b7ec4d7';
        window.DIConv.Bugsnag.user = { id: guid };
        if (window.document.domain.includes('local')) {
            window.DIConv.Bugsnag.releaseStage = 'local';
        }
        window.DIConv.Bugsnag.beforeNotify = (payload, metaData) => {
            // our files are served from econ.dealerinspire.com
            if (!metaData || !metaData.script || metaData.script.src) return true;
            let isOurError = metaData.script.src.indexOf('dealerinspire') !== -1;
            return !isOurError;
        };
    }
}

function renderApp(config: InlineConfig) {
    if (!store) store = configureStore(config);
    createRootDOMElement();
    ReactDOM.render(<Root store={store} />, document.getElementById(rootDivId));
}

function createRootDOMElement() {
    let el = document.createElement('div');
    el.setAttribute('id', rootDivId);
    window.document.body.appendChild(el);
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/index.tsx